
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../store/httpClient";
@Component
export default class ValidationSettings extends Vue {
	@Prop()
	private rohmaterialId!: number;
	@Prop()
	private materialBezeichnung!: string;
	private loading: boolean = false;
	private parameter: any = null;
	private formVorlagen: any = [];

	@Watch("rohmaterialId")
	private async loadSettings() {
		try {
			if (this.rohmaterialId == null) {
				return;
			}
			this.loading = true;
			const responseVorlagen = httpClient().get(`Material/GetFormVorlagen`);
			const response = await httpClient().get(
				`Material/GetValidationParameter?materialId=${this.rohmaterialId}`
			);
			this.formVorlagen = (await responseVorlagen).data;
			this.parameter = response.data;
		} catch {
			console.log("Loading settings failed.");
		} finally {
			this.loading = false;
		}
	}

	private get gewindeFormVorlagen() {
		return this.formVorlagen.filter((v: any) => v.featureType == 7);
	}

	private get senkungFormVorlagen() {
		return this.formVorlagen.filter((v: any) => v.featureType == 8);
	}

	private get durchzugFormVorlagen() {
		return this.formVorlagen.filter((v: any) => v.featureType == 9);
	}

	private get zylindersenkungFormVorlagen() {
		return this.formVorlagen.filter((v: any) => v.featureType == 13);
	}

	private add() {
		const neu = {
			toolId: 0,
			priceFactor: 1,
			setupCostPriceFactor: 1,
		};
		this.parameter.gewindeParameterDtos.push(neu);
	}

	private addSenkung() {
		const neu = {
			toolId: 0,
			priceFactor: 1,
			setupCostPriceFactor: 1,
		};
		this.parameter.senkungParameterDtos.push(neu);
	}

	private addZylindersenkung() {
		const neu = {
			toolId: 0,
			priceFactor: 1,
			setupCostPriceFactor: 1,
		};
		this.parameter.zylinderkopfSenkungParameterDtos.push(neu);
	}

	private addDurchzug() {
		const neu = {
			toolId: 0,
			priceFactor: 1,
			setupCostPriceFactor: 1,
		};
		this.parameter.durchzugParameterDtos.push(neu);
	}

	private addBendRadius() {
		const neu = {
			rohmaterialId: this.parameter.rohmaterialId,
			radius: 0,
			upperTolerance: 0,
			lowerTolerance: 0,
		};
		this.parameter.bendRadiuses.push(neu);
	}

	private addFalzRadius() {
		const neu = {
			rohmaterialId: this.parameter.rohmaterialId,
			radius: 0,
			upperTolerance: 0,
			lowerTolerance: 0,
		};
		this.parameter.falzRadiuses.push(neu);
	}

	private async speichern() {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`Material/SaveValidationParamter`,
				this.parameter
			);
			this.$store.commit("setSnackbarText", "Änderungen erfolgreich gespeichert.");
			this.$emit("close");
		} catch {
			console.log("Save validation setting failed.");
			this.$store.commit(
				"setSnackbarErrorText",
				"Änderungen konnten nicht gespeichert werden"
			);
		} finally {
			this.loading = false;
		}
	}

	private deleteGewinde(index: number) {
		this.parameter.gewindeParameterDtos.splice(index, 1);
	}

	private deleteSenkung(index: number) {
		this.parameter.senkungParameterDtos.splice(index, 1);
	}

	private deleteDurchzug(index: number) {
		this.parameter.durchzugParameterDtos.splice(index, 1);
	}

	private deleteZylindersenkung(index: number) {
		this.parameter.zylinderkopfSenkungParameterDtos.splice(index, 1);
	}

	private deleteBendRadius(index: number) {
		this.parameter.bendRadiuses.splice(index, 1);
	}

	private deleteFalzRadius(index: number) {
		this.parameter.falzRadiuses.splice(index, 1);
	}

	private back() {
		this.$emit("close");
	}
}
